module.exports = __webpack_public_path__ + "static/assets/d74f648fc0dc5aa2f72759d82328a524.svg";